var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full"},[_c('v-chart',{ref:"chart",staticClass:"price-chart",attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }